import { clsx, type ClassValue } from 'clsx'
import { twMerge } from 'tailwind-merge'

/** Tailwind class merger. Use instead of raw template literals. */
export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}

const dateFmt = new Intl.DateTimeFormat('ko-KR', {
  year: 'numeric',
  month: '2-digit',
  day: '2-digit',
  hour: '2-digit',
  minute: '2-digit',
  hour12: false,
})

/** Absolute date in ko-KR formatting. Returns '-' for missing/zero. */
export function formatTime(unix?: number | null) {
  if (!unix) return '-'
  return dateFmt.format(new Date(unix * 1000))
}

/**
 * Tiny relative-time helper. Returns strings like "방금 전", "3분 전", "2시간 전",
 * "5일 전". For values older than 30 days, falls back to absolute date.
 */
export function relativeTime(unix?: number | null) {
  if (!unix) return '-'
  const diff = Math.max(0, Math.floor(Date.now() / 1000) - unix)
  if (diff < 30) return '방금 전'
  if (diff < 3600) return `${Math.floor(diff / 60)}분 전`
  if (diff < 86400) return `${Math.floor(diff / 3600)}시간 전`
  if (diff < 30 * 86400) return `${Math.floor(diff / 86400)}일 전`
  return formatTime(unix)
}

